import { convertPoseStringIntoArray, convertPoseArrayIntoString } from './helper';

const initialState = {
  modalIsOpen: false,
  presentedModal: "DEFAULT",
  presentedModalIndexPath: "",
  presentedModalPoses:[],
  poseLookupString: "",
}

export default function (state = initialState, action) {
  const { type } = action;
  switch (type) {
    case 'PRESENT_MODAL':
      return {
        ...state,
        modalIsOpen:true,
        presentedModal: action.presentedModal,
        presentedModalIndexPath: action.indexPath,
        presentedModalPoses: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V"],
      };

    case 'CLOSE_MODAL':
      return {
        ...state,
        modalIsOpen:false,
        presentedModal:initialState.presentedModal,
        presentedModalIndexPath: "",
      };

    case 'UPDATE_POSE':

      const indexPathArray = action.indexPath.split("-")
      const section = indexPathArray[0]
      const row = indexPathArray[1]

      const array = convertPoseStringIntoArray(state.poseLookupString)

      array[section][row] = action.newPose

      const string = convertPoseArrayIntoString(array)

      return {
        ...state,
        modalIsOpen:false,
        poseLookupString: string,
      }

    case 'SET_POSELOOKUPSTRING_FROM_PARAM':
      return {
        ...state,
        poseLookupString:action.poseLookupString,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducer.js